import React, { useState, useEffect } from 'react'
import teacher from "../imgs/teacher.png"
import { Button, Form, Row, Col } from "react-bootstrap"
import Fade from 'react-reveal/Fade';
import InputField from '../components/InputField';
import { useStateMachine } from "little-state-machine";
import { useForm } from "react-hook-form";
import updateAction from "../updateAction";
import * as yup from "yup";
import { Navigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup"
import { Helmet } from 'react-helmet'
import { useNavigate } from "react-router-dom";

const Sstep5 = (props) => {
    let navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "all"
        , resolver: yupResolver(schema)
    });
    const { state, actions } = useStateMachine({ updateAction });
    const onSubmit = data => {
        toBase64(data.photo[0]).then(data => {
            actions.updateAction({ base64Photo: data });
            navigate("/Sfinal", { replace: true });
        });
    };

    const [go, setgo] = useState(false);

    useEffect(() => {
        if (!state.firstname) {
            setgo(true);
        }
    });
    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    return (
        <>
            <Helmet>
                <title>Registration</title>
            </Helmet>
            {/* {go && (
                <Navigate to='/Sstep1' />
            )} */}
            <div className="bg"></div>
            <div className="bg bg2"></div>
            <div className="bg bg3"></div>
            {/* <div className="content"> */}

            <div className="container1">

                <div className="wrapper1">
                    <ul className="steps">
                        <li className="is-active">Step 6 of 6</li>
                    </ul>
                    <form className="form-wrapper1" onSubmit={handleSubmit(onSubmit)}>

                        <fieldset className="section is-active">
                            <Fade>
                                <>
                                    <h3>Welcome, {state.firstname}</h3>
                                    <p>Tell us a little more about yourself</p>
                                    <h4>Please upload a clear photo of yourself</h4>
                                    <InputField register={register} name="photo" errorinfo={errors} label="" type="file" />

                                    <Button type="submit">Finish</Button>
                                </>
                            </Fade>
                        </fieldset>

                    </form>
                </div>
            </div>


            {/* </div> */}
        </>
    )
}

function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
const schema = yup.object().shape({
    //yup validation to make sure the photo is a file of type jpg, png, or jpeg
    photo: yup.mixed().required("Please upload a clear photo of yourself").test('filetype', "Please upload a clear photo of yourself, File must be a jpg, png, or jpeg", value => {
        if (value && value[0]) {
            if (value[0].size < 1)
                return false;
            return value[0].type === 'image/jpeg' || value[0].type === 'image/png' || value[0].type === 'image/jpg'
        }
    }).test('filesize', "This Image is to large, image size must be below 500 KB. You can use https://imagecompressor.com/ to compress your image or try another image.", value => {
        if (value && value[0]) {
            if (value[0].size > 500000) {
                return false;
            }
            return true;
        }
    })
})
export default Sstep5
